import { useGetNotificationV2 } from "api/investor/queries";
import { logoutAndRedirect } from "api/user";
import { Amplify } from "aws-amplify";
import Notification from "components/InvestorCommon/Notification/Notification";
import { useAppDispatch, useAppSelector } from "hooks/reduxHook";
import Cookies from "js-cookie";
import moment from "moment";
import { routesEnum } from "pages/Routes";
import { FC, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { getUser } from "store/ducks/investor/slice";
import { setType } from "store/ducks/system/slice";
import { IMAGES } from "utils/images";
import * as appSync from "../../api/notification/appsync.js";
import { expandIconPng } from "./styled";

interface IHeaderMobileProps {
	setMenuCollapse: () => void;
	showAnnouncement: boolean;
	setShowAnnouncement: any;
}

type IRightHeader = IHeaderMobileProps;

const Left: FC = () => {
	return (
		<div className="items-start">
			<Link to={routesEnum.home}>
				<img alt="" src={IMAGES.logo.logo_red} className="inline-block h-10" />
			</Link>
		</div>
	);
};

Amplify.configure(appSync.config);

const channel = {
	LOG_OUT: "LOG_OUT",
};

const Right = ({ setMenuCollapse, setShowAnnouncement, showAnnouncement }: IRightHeader) => {
	const [showNotification, setShowNotification] = useState(false);
	const dataUser = useAppSelector(getUser);
	const dispatch = useAppDispatch();
	const location = useLocation();
	const furthestDate = moment(new Date()).subtract(2, "month").toISOString();
	const { data, refetch } = useGetNotificationV2(furthestDate, dataUser?.id || "", {
		enabled: !!dataUser?.id,
	});
	const [totalNotification, setTotalNotification] = useState(0);
	const listNotification = data || [];

	useEffect(() => {
		const intervalId = setInterval(() => {
			refetch();
		}, 1000 * 5);
		return () => clearInterval(intervalId);
	}, [refetch, data]);

	const handleLogout = async () => {
		toast.success("Logout successfully!", {
			autoClose: 1000,
		});
		dispatch(setType(""));
		const currentRoute = `${location.pathname}${location.search}`;
		await logoutAndRedirect(currentRoute);
	};

	useEffect(() => {
		const userBeUnactive = appSync.subscribe(
			channel.LOG_OUT,
			({ data }: any) => {
				data = JSON.parse(String(data));
				if (data?.ids?.includes(dataUser?.id)) {
					handleLogout();
				}
			},
			undefined,
		);
		return () => {
			userBeUnactive.unsubscribe();
		};
	}, []);
	useEffect(() => {
		if (Array.isArray(data)) {
			const listTotalNotiUnread = data.filter((item) => item.noti_status);
			setTotalNotification(listTotalNotiUnread?.length);
		}
	}, [data]);
	return (
		<div className="z-50 flex flex-row items-center gap-6">
			<div className="relative cursor-pointer" onClick={setMenuCollapse}>
				<img src={expandIconPng} alt="" />
			</div>
			<div
				className="relative cursor-pointer"
				onClick={() => {
					setShowAnnouncement(!showAnnouncement);
					setShowNotification(false);
				}}
			>
				<img src={IMAGES.header.news} alt="" />
				<span className="-translate-y-2 absolute top-0 right-0 inline-block h-2 w-2 translate-x-2 transform rounded-full bg-orange-600"></span>
			</div>
			<div
				className="relative cursor-pointer"
				onClick={() => {
					setShowNotification(!showNotification);
					setShowAnnouncement(false);
				}}
			>
				<img src={IMAGES.header.notification} alt="" />
				<span className="-translate-y-4 absolute top-0 right-0 inline-flex translate-x-5 transform items-center justify-center rounded-full bg-orange-600 px-2 py-1 font-bold text-orange-100 text-xs leading-none">
					{totalNotification}
				</span>
				{showNotification && (
					<div className="absolute" style={{ right: "-10px", top: "40px" }}>
						<Notification
							listNotification={listNotification}
							refetch={refetch}
							setShowNotification={() => setShowNotification(!showNotification)}
						/>
					</div>
				)}
			</div>
			<div className="flex-grow cursor-pointer">
				<img
					alt=""
					src={IMAGES.header.black_logout}
					width="24px"
					height="24px"
					onClick={handleLogout}
				/>
			</div>
		</div>
	);
};

const HeaderMobile = ({
	setMenuCollapse,
	setShowAnnouncement,
	showAnnouncement,
}: IHeaderMobileProps) => {
	return (
		<div
			style={{
				maxWidth: "100%",
			}}
		>
			<div
				className="fixed top-0 z-50 flex w-full flex-row items-center justify-between gap-5 bg-white py-6 pr-4 pl-6 shadow-lg sm:py-10 sm:pr-8 sm:pl-10"
				style={{
					maxWidth: "100%",
				}}
			>
				<Left />
				<Right
					setMenuCollapse={setMenuCollapse}
					setShowAnnouncement={setShowAnnouncement}
					showAnnouncement={showAnnouncement}
				/>
			</div>
			<div className="h-20 w-full"></div>
		</div>
	);
};

export default HeaderMobile;
